export const getProviderName = (source: string): string => {
  if (source.startsWith("BDB")) {
    return getLegacyProviderName(source);
  }
  return source.split("_")[0].toLowerCase();
};

const getLegacyProviderName = (source: string): string => {
  return source.split("_")[1] + " " + source.split("_")[0];
};
